import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { StringsDataMap } from '../types/Types'

import { RootState } from '.'

interface StringState {
	data: StringsDataMap | undefined
}

const initialState: StringState = {
	data: undefined,
}

export const stringSlice = createSlice({
	name: 'string',
	initialState,
	reducers: {
		updateStrings: (state, action: PayloadAction<StringsDataMap>) => {
			state.data = action.payload
		},
	},
})

export const { updateStrings } = stringSlice.actions

export const selectStrings = (state: RootState): StringState['data'] => {
	return state.string.data
}

export default stringSlice.reducer
